import React, { forwardRef } from 'react';

type FileInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const FileField = forwardRef<HTMLInputElement, FileInputProps>((props, ref) => {
    const { id = 'file_input', className = '', ...rest } = props;

    return (
        <div className="position-relative">
            <input
                ref={ref}
                type="file"
                id={id}
                className={`form-control btn_add ${className}`}
                {...rest}
            />
            <label
                htmlFor={id}
                className="browser_file_filed position-absolute top-0 end-0 h-100  align-items-center px-3 border-start"
                style={{ minWidth: '80px', cursor: 'pointer' }}
            >
                Browse
            </label>
        </div>
    );
})

export default FileField;
